import { render } from "./Bidder.vue?vue&type=template&id=3b1a80c4"
import script from "./Bidder.vue?vue&type=script&lang=js"
export * from "./Bidder.vue?vue&type=script&lang=js"

import exportComponent from "/Users/aron/Herd/de-veense-veiling/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__